import { ITicketCommon } from '@@sapporo/ticket/interface/ITicketCommon';
import { formatPriceInfo } from '@/utils';
import clsx from 'clsx';
import React from 'react';

import styles from './LeisurePriceDiscount.module.scss';
import { ITicketCommonV3 } from '@/models/Leisure/interfaces/payloads/ILeisureProductsPayload';
import { has } from 'ramda';

interface ILeisurePriceDiscountProps {
  item: ITicketCommon | ITicketCommonV3;
  /** 할인율 노출 여부 */
  exposeRate?: boolean;
  className?: string;
}

const hasText = (item: ITicketCommon | ITicketCommonV3): item is ITicketCommonV3 => has('text', item.status);

const LeisurePriceDiscount: React.FC<ILeisurePriceDiscountProps> = ({ className, item, exposeRate }) => {
  if (item.status.type !== 'SALE') {
    return (
      <p className={clsx(styles.wrap, className)}>
        <span className={styles.dimmed}>{hasText(item) ? item.status.text : '판매완료'}</span>
      </p>
    );
  }

  if (!item.price.discount) {
    return null;
  }

  const priceInfo = formatPriceInfo(item.price.discount);
  const rate = exposeRate && item.price.discount.exposeRate && item.price.discount.rate;

  return (
    <div className={clsx(styles.wrap, className)}>
      {rate && <span className={styles.rate}>{rate}</span>}
      <span className={styles.amount}>{priceInfo?.amount}</span>
      <span className={styles.unit}>{priceInfo?.unit}~</span>
    </div>
  );
};

export default LeisurePriceDiscount;
